export default __webpack_public_path__ + "static/media/zenith-logo.e1c8c26c.png";